// extracted by mini-css-extract-plugin
export default {"content":"BX","description":"BY","header":"BZ","image":"Ba","title":"Bb"};